module.exports = __webpack_public_path__ + "static/media/template4-carousel.b0477462.webp";